export default {
  beAnalyticsReport: "backend-analytics-report",
  beJournals: "backend-journals",
  beJournal: "backend-journal",
  beJournalDestroy: "backend-journal-destroy",
  beJournalActionCallouts: "backend-journal-action-callouts",
  beProjects: "backend-projects",
  beProject: "backend-project",
  beRecentProjects: "backend-recent-projects",
  beStats: "backend-stats",
  beCreateTestMail: "backend-create-test-email",
  beResource: "backend-resource",
  beResources: "backend-resources",
  beResourceCollection: "backend-resource-collection",
  beResourceCollections: "backend-resource-collections",
  beResourceCollectionDestroy: "backend-resource-collection-destroy",
  beResourceCollectionUpdate: "backend-resource-collection-update",
  beResourceCollectionResources: "backend-resource-collection-resources",
  beResourceCollectionCreate: "backend-collection-create",
  beResourceDestroy: "backend-resource-destroy",
  beStylesheetShow: "backend-stylesheet-show",
  beStylesheetUpdate: "backend-stylesheet-update",
  beStylesheetCreate: "backend-stylesheet-create",
  beStylesheetDestroy: "backend-stylesheet-destroy",
  beEvents: "backend-events",
  beEventDestroy: "backend-event-destroy",
  beText: "backend-text",
  beMaker: "backend-maker",
  beMakers: "backend-makers",
  beMakerCreate: "backend-maker-create",
  beMakerUpdate: "backend-maker-update",
  beMakerDestroy: "backend-maker-destroy",
  beUser: "backend-user",
  beUsers: "backend-users",
  beUserCreate: "backend-user-create",
  beUserUpdate: "backend-user-update",
  beUserDestroy: "backend-user-destroy",
  beEntitlementImport: "backend-entitlement-import-create",
  beEntitlementTargets: "backend-entitlement-targets",
  beProjectEntitlement: "backend-project-entitlement",
  beProjectEntitlements: "backend-project-entitlements",
  beProjectEntitlementCreate: "backend-project-entitlement-create",
  beProjectEntitlementDestroy: "backend-project-entitlement-destroy",
  beProjectExportation: "backend-project-exportation",
  beProjectExportations: "backend-project-exportations",
  beProjectExportationCreate: "backend-project-exportation-create",
  beProjectExportationDestroy: "backend-project-exportation-destroy",
  beExportTarget: "backend-export-target",
  beExportTargets: "backend-export-targets",
  beExportTargetCreate: "backend-export-target-create",
  beExportTargetUpdate: "backend-export-target-update",
  beExportTargetDestroy: "backend-export-target-destroy",
  beTextUpdate: "backend-text-update",
  beTextDestroy: "backend-text-destroy",
  beTextCreate: "backend-text-create",
  beTextCategoryUpdate: "backend-text-category-update",
  beTextCategoryCreate: "backend-text-category-create",
  beTextCategoryDestroy: "backend-text-category-destroy",
  beTextCategory: "backend-text-category",
  beTextSectionCreate: "backend-text-section-create",
  beTextSectionUpdate: "backend-text-section-update",
  beTextSectionDestroy: "backend-text-section-destroy",
  beTextSectionIngest: "backend-text-section-ingest",
  beTextSectionIngestUpdate: "backend-text-section-ingest-update",
  beProjectUpdate: "backend-project-update",
  beProjectDestroy: "backend-project-destroy",
  beIngestionCreate: "backend-ingestion-create",
  beIngestionShow: "backend-ingestion-show",
  bePageDestroy: "backend-page-destroy",
  bePageUpdate: "backend-page-update",
  bePageCreate: "backend-page-create",
  bePage: "backend-page",
  beFeatures: "backend-features",
  beFeatureDestroy: "backend-feature-destroy",
  beFeatureUpdate: "backend-feature-update",
  beFeatureCreate: "backend-feature-create",
  beFeature: "backend-feature",
  beSubjects: "backend-subjects",
  beSubject: "backend-subject",
  beSubjectDestroy: "backend-subject-destroy",
  beSubjectUpdate: "backend-edit-subject",
  beTwitterQueries: "backend-twitter-queries",
  beTwitterQuery: "backend-twitter-query",
  beTwitterQueryDestroy: "backend-twitter-query-destroy",
  beTwitterQueryUpdate: "backend-twitter-query-update",
  beTwitterQueryCreate: "backend-twitter-query-create",
  beTwitterQueryFetch: "backend-twitter-query-fetch",
  bePermissions: "backend-permissions",
  bePermission: "backend-permission",
  bePermissionCreate: "backend-permission-create",
  bePermissionUpdate: "backend-permission-update",
  bePermissionDestroy: "backend-permission-destroy",
  beResourceImportFetch: "backend-resource-import-fetch",
  beVersions: "backend-versions",
  beProjectAnalytics: "backend-project-analytics",
  beProjectCollections: "backend-project-collections",
  beProjectCollection: "backend-project-collection",
  beProjectCollectionDestroy: "backend-project-collection-destroy",
  beProjectCollectionCreate: "backend-project-collection-create",
  beProjectCollectionUpdate: "backend-project-collection-update",
  beCollectionProjectReorder: "backend-collection-project-reorder",
  beCollectionProjectUpdate: "backend-collection-project-update",
  beActionCallouts: "backend-action-callouts",
  beProjectActionCallouts: "backend-project-action-callouts",
  beCollectionProjects: "backend-collection-projects",
  beCollectionProjectsPaginated: "backend-collection-projects-paginated",
  beCollectionProjectsCreate: "backend-collection-projects-create",
  beCollectionProjectsDestroy: "backend-collection-projects-destroy",
  beProjectContentBlocks: "backend-project-content-blocks",
  beContentBlockCreate: "backend-content-block-create",
  beContentBlockUpdate: "backend-content-block-update",
  beContentBlockDestroy: "backend-content-block-destroy",
  beContentBlock: "backend-content-block",
  beActionCallout: "backend-action-callout",
  beActionCalloutDestroy: "backend-action-callout-destroy",
  beActionCalloutCreate: "backend-action-callout-create",
  beActionCalloutUpdate: "backend-action-callout-update",
  feProject: "frontend-project",
  tmpProject: "project-detail",
  feMyReadingGroups: "frontend-my-reading-groups",
  fePublicReadingGroups: "frontend-public-reading-groups",
  feNewReadingGroup: "frontend-new-reading-group",
  feReadingGroup: "frontend-reading-group",
  feReadingGroupDestroy: "frontend-reading-group-destroy",
  feReadingGroupClone: "frontend-reading-group-clone",
  feReadingGroupMembers: "frontend-reading-group-members",
  feReadingGroupAnnotations: "frontend-reading-group-annotations",
  feReadingGroupsLookup: "frontend-reading-groups-lookup",
  feReadingGroupMembershipCreate: "frontend-reading-group-membership-create",
  feReadingGroupMembershipDestroy: "frontend-reading-group-membership-destroy",
  feReadingGroupMembershipShow: "frontend-reading-group-membership-show",
  feReadingGroupMembershipEdit: "frontend-reading-group-membership-edit",
  feReadingGroupMembershipArchive: "frontend-reading-group-membership-archive",
  feReadingGroupMembershipActivate:
    "frontend-reading-group-membership-activate",
  feReadingGroupCollectedProjects: "frontend-reading-group-collected-projects",
  feReadingGroupCollectedTexts: "frontend-reading-group-collected-texts",
  feReadingGroupCollectedTextSections:
    "frontend-reading-group-collected-text-sections",
  feReadingGroupCollectedResourceCollections:
    "frontend-reading-group-collected-resource-collections",
  feReadingGroupCollectedResources:
    "frontend-reading-group-collected-resources",
  feReadingGroupCategories: "frontend-reading-group-categories",
  feReadingGroupCategoryCreate:
    "frontend-reading-group-collection-category-create",
  feReadingGroupCategoryUpdate:
    "frontend-reading-group-collection-category-update",
  feReadingGroupCategoryDestroy:
    "frontend-reading-group-collection-category-destroy",
  feProjectsFiltered: "frontend-projects-filtered",
  feProjectsFeatured: "frontend-projects-featured",
  feFeatures: "frontend-features",
  feEvents: "frontend-events",
  feSubjects: "frontend-subjects",
  feSubjectsFeatured: "frontend-subjects-featured",
  feResources: "frontend-resources",
  feResource: "frontend-resource",
  feSlideshow: "frontend-slideshow",
  feResourceCollection: "frontend-resource-collection",
  feResourceCollections: "frontend-resource-collections",
  feCollectionResources: "frontend-collection-resources",
  feCollectionResource: "frontend-collection-resource",
  feUnsubscribe: "frontend-unsubscribe",
  feProjectCollections: "frontend-project-collections",
  feProjectCollection: "frontend-project-collection",
  feCollectionProjects: "frontend-collection-projects",
  feCollectCollectable: "frontend-collect-collectable",
  feUncollectCollectable: "frontend-uncollect-collectable",
  feMyCollection: "frontend-my-collection",
  feMyCollectedProjects: "frontend-my-collected-projects",
  feMyCollectedTexts: "frontend-my-collected-texts",
  feMyCollectedTextSections: "frontend-my-collected-text-sections",
  feMyCollectedResourceCollections:
    "frontend-my-collected-resource-collections",
  feMyCollectedResources: "frontend-my-collected-resources",
  feMyAnnotations: "frontend-my-annotations",
  feMyAnnotatedTexts: "frontend-my-annotated-texts",
  rText: "reader-text",
  rSection: "reader-section",
  rAnnotations: "reader-annotations",
  rMyAnnotationsForText: "reader-my-annotations-for-text",
  rMyFilteredAnnotationsForText: "reader-my-filtered-annotations-for-text",
  rReadingGroupAnnotationsForText: "reader-reading-group-annotations-for-text",
  rReadingGroupFilteredAnnotationsForText:
    "reader-reading-group-filtered-annotations-for-text",
  rResources: "reader-resources",
  rSectionResources: "reader-section-resources",
  rSectionResourceCollections: "reader-section-resource-collections",
  rResource: "reader-resource",
  rResourceCollection: "reader-resource-collection",
  rAnnotationCreate: "reader-annotation-create",
  rAnnotationUpdate: "reader-annotation-update",
  rAnnotationDestroy: "reader-annotation-destroy",
  rAnnotationFlag: "reader-annotation-flag",
  rAnnotationUnflag: "reader-annotation-unflag",
  rCommentCreate: "reader-comment-create",
  rCommentDestroy: "reader-comment-destroy",
  rCommentUpdate: "reader-comment-update",
  rCommentFlag: "reader-comment-flag",
  rCommentUnflag: "reader-comment-unflag",
  rDrawerAnnotations: "reader-drawer-annotations",
  rSearchResults: "reader-search-results",
  feResourceAnnotationDestroy: "reader-resource-annotation-destroy",
  feCollectionAnnotationDestroy: "reader-collection-annotation-destroy",
  gAuthenticatedUserUpdate: "global-authenticated-user-update",
  gAuthenticatedUserNotificationsUpdate:
    "global-authenticated-user-notifications-update",
  gPages: "global-pages",
  gPage: "global-page",
  gPasswordRequest: "global-password-request",
  gPasswordReset: "global-password-reset",
  gCreateUser: "global-create-user",
  gContactForm: "global-contact-form",
  gLogin: "global-login",
  settings: "settings",
  analyticsEventCreate: "analytics-event-create"
};
